@if (!bookmark && !activeUserStore.isGuestView()) {
  <div
    [style]="{ 'z-index': 510 }"
    class="fixed flex bottom-0 right-0 m-3 align-items-end gap-2 pointer-events-none z-overlay-backdrop">
    <app-district-report-dropdown class="pointer-events-auto" />

    @if (!gridStore.readonly()) {
      @if (gridStore.layout().length > 0) {
        <p-button
          class="pointer-events-auto"
          pTooltip="Neue Ansicht zusammenstellen"
          tooltipPosition="top"
          [rounded]="true"
          icon="fas fa-screwdriver-wrench"
          (click)="addNewView()" />
      }
      <app-widget-adder
        #widgetAdder
        class="pl-2"
        (addWidget)="add($event)"></app-widget-adder>
    }
    @if (gridStore.activeBookmark()) {
      <app-atlas-edit-button class="pointer-events-auto" />
    }
  </div>
}

<div
  [ngClass]="{ 'gs-readonly': gridStore.readonly() }"
  class="grid-stack"
  [id]="gridId"></div>
<div #dynamicContainer></div>

@if (activeWidget && activeConfig && currentWidgetConfig) {
  <p-sidebar
    styleClass="w-5"
    [position]="widgetStore.configPosition()"
    [visible]="!!activeConfig"
    (onHide)="finalizeConfig()"
    [blockScroll]="true"
    [modal]="false">
    @if (widgetStore.poiFastSwitch()) {
      <div class="flex flex-column">
        <app-poi-checkboxes></app-poi-checkboxes>
        <p-divider />
        <p-button
          size="small"
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          label="schließen"
          icon="fas fa-xmark-circle"
          (onClick)="finalizeConfig()" />
      </div>
    } @else {
      <p-stepper [activeStep]="getActiveStep()" class="h-full w-full">
        @if (configService.canActivateStep(activeWidget.type, 'data')) {
          <p-stepperPanel header="Raum">
            <ng-template
              pTemplate="content"
              let-nextCallback="nextCallback"
              let-index="index">
              <div class="flex flex-grow-1 flex-column w-full">
                <div
                  class="flex-grow-1 flex flex-column justify-content-start align-content-start">
                  <app-widget-data-layer></app-widget-data-layer>
                </div>
                <div
                  class="border-top-1 surface-border flex pt-4 justify-content-between gap-3">
                  <p-button
                    size="small"
                    severity="secondary"
                    [rounded]="true"
                    label="abbrechen"
                    [text]="true"
                    icon="fas fa-xmark-circle"
                    (onClick)="cancel()" />
                  <p-button
                    class="ml-auto"
                    size="small"
                    [rounded]="true"
                    label="weiter"
                    icon="fas fa-arrow-right"
                    iconPos="right"
                    (onClick)="nextCallback.emit()" />
                  <p-button
                    size="small"
                    [rounded]="true"
                    label="übernehmen"
                    icon="fas fa-check-circle"
                    iconPos="right"
                    (onClick)="finalizeConfig()" />
                </div>
              </div>
            </ng-template>
          </p-stepperPanel>
        }
        @if (configService.canActivateStep(activeWidget.type, 'indicators')) {
          <p-stepperPanel header="Indikatoren">
            <ng-template
              pTemplate="content"
              let-prevCallback="prevCallback"
              let-nextCallback="nextCallback"
              let-index="index">
              <div class="flex flex-grow-1 flex-column w-full">
                <div
                  class="flex-grow-1 flex flex-column justify-content-start align-content-start overflow-auto">
                  <app-widget-indicators></app-widget-indicators>
                </div>
                <div
                  class="flex-shrink-0 border-top-1 surface-border flex pt-4 justify-content-between gap-3">
                  <p-button
                    size="small"
                    [rounded]="true"
                    severity="secondary"
                    label="abbrechen"
                    [text]="true"
                    icon="fas fa-xmark-circle"
                    (onClick)="cancel()" />
                  @if (
                    configService.canActivateStep(activeWidget.type, 'data')
                  ) {
                    <p-button
                      size="small"
                      [rounded]="true"
                      label="zurück"
                      [text]="true"
                      icon="fas fa-arrow-left"
                      (onClick)="prevCallback.emit()" />
                  }
                  @if (
                    configService.canActivateStep(
                      activeWidget.type,
                      'customize'
                    )
                  ) {
                    <p-button
                      class="ml-auto"
                      size="small"
                      [rounded]="true"
                      [outlined]="true"
                      severity="secondary"
                      label="individualisieren"
                      pTooltip="(optional)"
                      tooltipPosition="top"
                      icon="fas fa-cog"
                      iconPos="right"
                      (onClick)="nextCallback.emit()" />
                  }
                  <p-button
                    size="small"
                    [rounded]="true"
                    label="erstellen"
                    pTooltip="übernehmen und anzeigen"
                    tooltipPosition="top"
                    icon="fas fa-check-circle"
                    iconPos="right"
                    (onClick)="finalizeConfig()" />
                </div>
              </div>
            </ng-template>
          </p-stepperPanel>
        }

        @if (configService.canActivateStep(activeWidget.type, 'customize')) {
          <p-stepperPanel header="Individualisieren">
            <ng-template
              pTemplate="content"
              let-prevCallback="prevCallback"
              let-index="index">
              <div class="flex flex-grow-1 flex-column w-full">
                <div
                  class="flex-grow-1 flex flex-column justify-content-start align-content-start overflow-auto">
                  <app-widget-config-form
                    (configChange)="onWidgetConfigChange($event)"
                    [config]="currentWidgetConfig"
                    [type]="activeWidget.type"
                    [options]="formOptions"></app-widget-config-form>
                </div>
                <div
                  class="border-top-1 surface-border flex pt-4 justify-content-between gap-3">
                  <p-button
                    size="small"
                    [rounded]="true"
                    severity="secondary"
                    label="abbrechen"
                    [text]="true"
                    icon="fas fa-xmark-circle"
                    (onClick)="cancel()" />
                  @if (
                    configService.canActivateStep(
                      activeWidget.type,
                      'indicators'
                    )
                  ) {
                    <p-button
                      class="ml-auto"
                      size="small"
                      [rounded]="true"
                      label="zurück"
                      [text]="true"
                      icon="fas fa-arrow-left"
                      (onClick)="prevCallback.emit()" />
                  }
                  <p-button
                    size="small"
                    [rounded]="true"
                    label="übernehmen"
                    icon="fas fa-check-circle"
                    (onClick)="finalizeConfig()" />
                </div>
              </div>
            </ng-template>
          </p-stepperPanel>
        }
      </p-stepper>
    }
  </p-sidebar>
  <app-mask [visible]="!!activeConfig"></app-mask>
}
@if (widgetStore.widgetToExport(); as widgetId) {
  <app-widget-export [widgetId]="widgetId" />
}

<p-confirmDialog key="newAtlasView" #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-exclamation-triangle"
        [text]="message.header"></app-header>

      @if (
        activeUserStore.context() === 'atlasInternal' ||
        (activeUserStore.isLoggedIn() &&
          globalStore.activeCommune()?._id === activeUserStore.user()?.commune)
      ) {
        <p>
          {{
            message.message || 'Ihre aktuelle Ansicht wird dabei zurückgesetzt.'
          }}
        </p>

        <div class="flex gap-3 align-items-center">
          <i class="ml-auto fas fa-arrow-right"></i>
          @if (gridStore.activeBookmark()) {
            <button
              size="small"
              [text]="true"
              [rounded]="true"
              (click)="saveAndClose(); cd.reject()"
              pButton
              icon="fas fa-save"
              label="speichern und schließen"></button>
          } @else {
            <button
              size="small"
              [text]="true"
              [rounded]="true"
              (click)="cancelAndAdd(); cd.reject()"
              severity="success"
              pButton
              icon="fas fa-plus-circle"
              label="anlegen"></button>
          }
        </div>
        <p-divider />
      } @else {
        <p>Nicht gespeicherte Änderungen gehen verloren.</p>
      }

      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          icon="fas fa-check"
          label="ja, fortfahren"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<div id="chart-js--tooltip-container"></div>
